import FieldType from "./field-type";
import FieldSystemType from "./field-system-type";

interface IFieldTypeConfig {
    [fieldType: string]: {
        id: FieldType,
        systemType: FieldSystemType
    }
};

const FieldTypeConfig: IFieldTypeConfig = {};

FieldTypeConfig[FieldType.text] = {
    id: FieldType.text,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.textarea] = {
    id: FieldType.textarea,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.email] = {
    id: FieldType.email,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.phone] = {
    id: FieldType.phone,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.datetime] = {
    id: FieldType.datetime,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.image] = {
    id: FieldType.image,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.check] = {
    id: FieldType.check,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.url] = {
    id: FieldType.url,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.formula] = {
    id: FieldType.formula,
    systemType: FieldSystemType.string
};

FieldTypeConfig[FieldType.number] = {
    id: FieldType.number,
    systemType: FieldSystemType.number
};

FieldTypeConfig[FieldType.linked] = {
    id: FieldType.linked,
    systemType: FieldSystemType.linked
};

FieldTypeConfig[FieldType.lookup] = {
    id: FieldType.lookup,
    systemType: FieldSystemType.linked
};

FieldTypeConfig[FieldType.uid] = {
    id: FieldType.uid,
    systemType: FieldSystemType.uid
};

export default FieldTypeConfig;